export const routesPath = {
  root: '/',
  authenticate: '/autenticacao',
  authenticateToken: '/autenticacao-sso',
  recoveryPassword: '/recuperar-senha',
  dashboard: {
    home: '/dashboard',
    chat: '/dashboard/chat',
    panels: '/dashboard/paineis',
    bigQuestions: '/dashboard/big-questions',
    bigViews: '/dashboard/big-views',
    bigNumbers: '/dashboard/big-numbers',
    configs: '/dashboard/configuracoes',
    faq: '/dashboard/faq',
    conversions: '/dashboard/conversions',
    marketShare: '/dashboard/market-share',
    myPanels: '/dashboard/my-panels',
    hourByHour: '/dashboard/hour-by-hour',
    fidelity: '/dashboard/fidelity',
    proposals: '/dashboard/proposals',
    groupVision: (groupCode: string) =>
      `/dashboard/grupos/${encodeURIComponent(groupCode)}`,
  },
} as const
